<template>
  <div class="my-3 px-3">
    <!-- ピル部分 -->
    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
      <li class="nav-item" role="presentation">
        <button type="button" class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">ホーム</button>
      </li>
      <li class="nav-item" role="presentation">
        <button type="button" class="nav-link" id="pills-use-tab" data-bs-toggle="pill" data-bs-target="#pills-use" role="tab" aria-controls="pills-use" aria-selected="false">使い方・説明</button>
      </li>
    </ul>
    <!-- パネル部分 -->
    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade show active calc" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
        <AlertModal/>
        <PokemonCalculator/>
        <hr>
        <AutoSpeedControl/>
        <SupplementalInfo/>
      </div>
      <div class="tab-pane fade how2use" id="pills-use" role="tabpanel" aria-labelledby="pills-use-tab">
        <HowToUse/>
      </div>
    </div>
  </div>
</template>

<script>
import AlertModal from '@/components/AlertModal.vue';
import PokemonCalculator from '@/components/PokemonCalculator.vue';
import HowToUse from '@/components/HowToUse.vue';
import AutoSpeedControl from '@/components/AutoSpeedControl.vue';
import SupplementalInfo from '@/components/SupplementalInfo.vue';

export default {
  name: 'HomeView',
  created(){
    this.sendNameListRequest();
  },
  methods:{
    /**
     * ポケモン名一覧を取得
     */
    sendNameListRequest(){
      /* Google App Scriptで構築したバックエンドにPOST */
      let P_URL=new URL("https://script.google.com/macros/s/AKfycbylhPI1yISh_8XR6OJp5BPD5EdE70BdvlflWaQHRJKguspBl5EPPK9yZy3d26GTnJcU/exec");
      const formData = new FormData();
      formData.append("handler","LIST");//バックエンドへの要求内容(ポケモン名一覧の送信)
      fetch(P_URL,{
        method:"POST",
        body: formData
      }).then(res=>{
        console.log(res);
        return res.text();
      }).then(data=>{
        this.initName(data);
      }).catch(e=>{
        this.$store.dispatch("alertModal/saveTitle","Error");
        this.$store.dispatch("alertModal/saveMessage",e + "\n少し時間をおいてからページを再読み込みしてください。");
        this.$store.dispatch("alertModal/changeFlagState");
      })
    },
    /**
     * ポケモン名一覧の登録
     * @param {JSON} str 
     */
    initName(str){
      this.$store.dispatch("pokemonList/savePokemonList",JSON.parse(str));//取得したリストを登録
    },
  },
  components: { AlertModal, PokemonCalculator, HowToUse, AutoSpeedControl, SupplementalInfo },
}
</script>

<style scoped>
.calc {
  font-size: 14px;
}
.how2use {
  font-size: 14px;
}
.nav-pills .nav-link.active{
    background-color: #ffa534;
    color: white;
}
/* タブの文字色変更 */
.nav-pills .nav-link{
    color: #ffa534;
}
</style>